import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import ProjectCount from "./ProjectCount";
import { getProjectUUIDAction} from "../../../store/projects/actions"
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import ProjectChart from "./chart/project-dashboard";
import {
    Row,
    Col,
    CardBody,
    Card,
    Container,
  } from "reactstrap"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Moment from "react-moment";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import RSPieChart from "components/charts/RSPieChart";
import DashboardDraftpiechart from "./chart/data/dashboard-draft-pie-chart";
import performance_img from '../../../assets/img/performance.png'
import cost_pc_img from '../../../assets/img/cost_pc.png'
import cost_pl_img from '../../../assets/img/cost_pl.png'
import projectIcon from "../../../assets/img/project-icon.png";
import clientIcon from "../../../assets/img/user-icon.png";
import leadIcon from "../../../assets/img/l-1.png";
import leadConversion from "../../../assets/img/conversion-icon.png";
import RsCardImgv2 from "components/Rscards/Rscard-imgv2";
import RsCardImgv3 from "components/Rscards/Rscard-imgv3";
import RSBarChart from "components/charts/RSBarChart";
import RsCardImgv4 from "components/Rscards/Rscard-imgv4";
import RsCardImgv5 from "components/Rscards/Rscard-imgv5";
class Campaign extends Component {
    constructor(props) {
        super(props)
        this.state = {
          activity5: [],
			reports: [
        { title: "Email Sent", iconClass: "bx-copy-alt", description: "14" },
        {
          title: "Performance",
          
          iconClass: "bx-archive-in",
          description: "6",
        },
        {
          title: "# SRR",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "# Clients",
          iconClass: "bx-purchase-tag-alt",
          description: "2",
        },
      ]
        }

     
      }

     
      componentDidMount() {

        const { match: { params }, ongetProjectUUIDAction } = this.props;
        const{ totalProspect, totalWorksheet, totalClient, costPerLead, costPerClient } = this.state;
        if (params && params.projectId) {
          //this.fetchLeadSourceData();
          //this.fetchBudgetSourceData();
          //this.fetchClientData();
          ongetProjectUUIDAction(params.projectId);
          this.fetchAllounts();
          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj?.resultData?.bearerToken;
          const str = `Bearer ${token}`;
           axios.get(`${API_URL}ProjectCampaignLeadActivities/allforagent`, {
          params: {
            agentId: localStorage.getItem("userId"),
          }, headers: { Authorization: str }
        })
          .then(res => {
            this.setState({ activity5: res.data });
          });
        }
      }  
      fetchAllounts = async () => {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const str = `Bearer ${token}`;
    
        try {
            const response = await axios.get(`${API_URL}Builder/getProjectBuilderDashboardByAgentQuery`, {
                params: {
                    agentId: localStorage.getItem("userId"),
                    builderId: this.props.match.params.id,
                    projectId: this.props.match.params.projectId,
                },
                headers: { Authorization: str }
            });
    
            if (response.data && typeof response.data === "object") {
              this.setState({
                  totalProspect: response.data.totalProspect || 0,
                  totalWorksheet: response.data.totalWorksheet || 0,
                  totalClient: response.data.totalClient || 0,
                  costPerLead: response.data.costPerLead || 0,
                  costPerClient: response.data.costPerClient || 0,
              });            
               
            }
        } catch (error) {
            console.error("Error fetching lead counts:", error);
        }
    };
fetchLeadSourceData = async (projectId) => {
  const agentId = localStorage.getItem("userId");
  //const builderId= this.props.match.params.id;
  
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const url = `${API_URL}ProjectExt/dashboard2?agentId=${agentId}&projectId=${projectId}`;

  try {
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

     const data = response.data;
     if (data && Array.isArray(data.leadSourceGraphData)) {
    
        const sources = data?.leadSourceGraphData.map(item => item.itemTitle || "Unknown");
        const counts = data?.leadSourceGraphData.map(item => parseInt(item.percentage) || 0);
      this.setState({
        leadSourceData: {
          series: counts,
          options: {
            chart: { type: "pie" },
            labels: sources,
            colors: ["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
            legend: {
              show: true,
              position: "bottom",
              horizontalAlign: "center",
              verticalAlign: "middle",
              floating: false,
              fontSize: "14px",
              offsetX: 0,
              offsetY: -10,
            },
            responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
          },
        },
      });
    }
  } catch (error) {
    this.setState({ error: error.message });
  }
};

fetchBudgetSourceData = async (projectId) => {
  const agentId = localStorage.getItem("userId");
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const url = `${API_URL}ProjectExt/dashboard2?agentId=${agentId}&projectId=${projectId}`;

  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = response.data;

    if (data && Array.isArray(data.budgetAllocationData)) {
      const sources = data.budgetAllocationData.map((item) => item.itemTitle);
      const plannedValues = data.budgetAllocationData.map((item) => Number(item.value1) || 0);
      const actualValues = data.budgetAllocationData.map((item) => Number(item.value2) || 0);

      this.setState({
        budgetData: {
          series: [
            { name: "Allocation", data: plannedValues },
            { name: "Spend", data: actualValues },
          ],
          options: {
            chart: { type: "bar", height: 400 ,
              toolbar: {
      show: false   
    }

            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
              },
            },
            dataLabels: { enabled: false },
            xaxis: { categories: sources },
            colors: ["#004aad", "#ffbd59"],
            legend: {
              show: true,
              position: "bottom",
              horizontalAlign: "center",
              fontSize: "14px",
            },
            responsive: [
              {
                breakpoint: 600,
                options: {
                  chart: { height: 440 },
                  legend: { show: false },
                },
              },
            ],
          },
        },
      });
    }
  } catch (error) {
    this.setState({ error: error.message });
  }
};


fetchClientData = async (projectId) => {
  const agentId = localStorage.getItem("userId");
  //const builderId= this.props.match.params.id;
  //const projectId = this.props.match.params.projectId;
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const url = `${API_URL}ProjectExt/dashboard2?agentId=${agentId}&projectId=${projectId}`;

  try {
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
    const data = response.data;
     if (data && Array.isArray(data.clientSourceGraphData)) {
    
        const sources = data?.clientSourceGraphData.map(item => item.itemTitle || "Unknown");
        const counts = data?.clientSourceGraphData.map(item => parseInt(item.percentage) || 0);
       
      this.setState({
        ClientData: {
          series: counts,
          options: {
            chart: { type: "pie" },
            labels: sources,
            colors: ["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
            legend: {
              show: true,
              position: "bottom",
              horizontalAlign: "center",
              verticalAlign: "middle",
              floating: false,
              fontSize: "14px",
              offsetX: 0,
              offsetY: -10,
            },
            responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
          },
        },
      });
    }
  } catch (error) {
    this.setState({ error: error.message });
  }
};
componentDidUpdate(prevProps) {
  if (prevProps.projectData !== this.props.projectData && this.props.projectData){
    
    this.fetchBudgetSourceData(this.props.projectData?.id);
    this.fetchClientData(this.props.projectData?.id);
    this.fetchLeadSourceData(this.props.projectData?.id);
  }
}
      render() {
       
        const { projectData, isResponsive } = this.props;
        const { totalProspect, totalWorksheet, totalClient, costPerClient, costPerLead, activity5  } = this.state;
        const filteredActivities = activity5.filter(item => item.activityParentRefGuid === this.props.match.params.projectId);
        return (
          <React.Fragment>
              <div className="page-content project-page-content ">

                <MetaTags>
                <title>Campaigns | Realty Space</title>
                </MetaTags>
                <Container fluid className="">
                <Row>
                    <Col sm='2' className="pe-0" >
                    <ProjectSidebar isResponsive={isResponsive} />
                     </Col>
                <Col sm='10' className="ps-0">
                <Row className="project-header">
                   <Col sm="7"  >
                <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Dashboard")} />
                </Col>
                <Col sm="4" className="">
                <h2 className="">{this.props.t( projectData.projectName)}</h2>
                </Col>
                </Row>
                {isResponsive ? (
                              <Card className="mt-4">
                                <CardBody>
                                    <Row className="text-center">
                           
                              <Col className="mb-2" xs={4}>
                                <div className="fw-bold fs-5" style={{fontSize:16}}>{totalProspect}</div>
                                <div className="" style={{fontSize:16}}>#Leads</div>
                              </Col>
                               <Col className="mb-2" xs={4}>
                                <div className="fw-bold fs-5" style={{fontSize:16}}>{totalWorksheet}</div>
                                <div className="" style={{fontSize:16}}>Worksheets filled</div>
                              </Col>
                               <Col className="mb-2" xs={4}>
                                <div className="fw-bold fs-5" style={{fontSize:16}}>{totalClient}</div>
                                <div className="" style={{fontSize:16}}>#Clients</div>
                              </Col>
                               <Col className="mb-2" xs={4}>
                                <div className="fw-bold fs-5" style={{fontSize:16}}>{costPerLead}</div>
                                <div className="" style={{fontSize:16}}>Cost per lead</div>
                              </Col>
                               <Col className="mb-2" xs={4}>
                                <div className="fw-bold fs-5" style={{fontSize:16}}>{costPerClient}</div>
                                <div className="" style={{fontSize:16}}>Cost per client</div>
                              </Col>
                                                      
                          </Row>
                                </CardBody>
                              </Card>
                          
                            ):(
                               <div className="d-flex justify-content-center gap-3 flex-wrap bg-yellow">
                                        
                              <div  className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(18% - 1rem)" }}>
                                <RsCardImgv5 title="#Leads" description={totalProspect}  />
                              </div>

                              <div  className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(18% - 1rem)" }}>
                                <RsCardImgv5 title="Worksheets filled
                                  " description={totalWorksheet}  />
                              </div>

                                <div  className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(18% - 1rem)" }}>
                                <RsCardImgv5 title="#Clients" description={totalClient}  />
                              </div>
                                <div  className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(18% - 1rem)" }}>
                                <RsCardImgv5 title="Cost per lead" description={costPerLead} />
                              </div>

                              <div  className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(18% - 1rem)" }}>
                                <RsCardImgv5 title="Cost per client" description={costPerClient}  />
                              </div>
                                               
                                   </div>
                            )}
        


                  <Row className="mt-4">
                      <Col lg={4} className="d-flex mb-2">
                      <div className="card border-full w-100">
                        <div className="card-body d-flex flex-column">
                           
                                  {this.state.leadSourceData && <RSPieChart title="Lead Sources" filter={false}  {...this.state.leadSourceData} />} 
                          </div>
                      </div>
                      </Col>

                      <Col lg={4} className="d-flex mb-2">
                       {this.state.ClientData && 
                      <div className="card border-full w-100">
                        <div className="card-body d-flex flex-column">
                           
                                  <RSPieChart title="Client Sources" filter={false}  {...this.state.ClientData} /> 
                          </div>
                      </div>
                      }
                      </Col>

                       <Col lg={4} className="d-flex mb-2">
                        {this.state.budgetData && 
                      <div className="card border-full w-100">
                        <div className="card-body d-flex flex-column">
                           
                                  <RSBarChart title="Budget Distribution" filter={false}  {...this.state.budgetData} />
                          </div>
                      </div>
                      } 
                      </Col>
                  </Row>


                </Col>
                </Row>
                </Container>
            </div>
          </React.Fragment>
        )
      }
}

Campaign.propTypes = {
    t:PropTypes.any,
    match:PropTypes.object,
    ongetProjectUUIDAction:PropTypes.func,
    projectData: PropTypes.object,
    isResponsive:PropTypes.object
  }
  const mapStateToProps = ({ Project }) => (
    {
      projectData: Project.projectData,
      loading:Project.loading
  
    })
  const mapDispatchToProps = dispatch => ({
    ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  });
export default connect( mapStateToProps,mapDispatchToProps )(withRouter(withTranslation()(Campaign)))
